module.exports = __webpack_public_path__ + "img/intp-selected.1ee57f68.png";